/**
 * PDP Icons
 * Icons used in Product Detail Pages
 */

export interface IconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  title?: string;
  className?: string;
  testId?: string;
}

export const Plus = ({ width = 24, height = 24, fill = 'currentColor', title, className }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={fill}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {title && <title>{title}</title>}
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const Minus = ({ width = 24, height = 24, fill = 'currentColor', title, className }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={fill}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {title && <title>{title}</title>}
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const ChevronLeft = ({ width = 24, height = 24, fill = 'currentColor', title, className, testId }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={fill}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    data-testid={testId}
  >
    {title && <title>{title}</title>}
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const Close = ({ width = 24, height = 24, fill = 'currentColor', title, className, testId }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={fill}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    data-testid={testId}
  >
    {title && <title>{title}</title>}
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const Trash = ({ width = 24, height = 24, fill = 'currentColor', title, className, testId }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={fill}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    data-testid={testId}
  >
    {title && <title>{title}</title>}
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <line x1="10" y1="11" x2="10" y2="17" />
    <line x1="14" y1="11" x2="14" y2="17" />
  </svg>
);

export const ShoppingBag = ({ width = 24, height = 24, fill = 'currentColor', title, className, testId }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={fill}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    data-testid={testId}
  >
    {title && <title>{title}</title>}
    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <path d="M16 10a4 4 0 0 1-8 0" />
  </svg>
);

